module.exports = __webpack_public_path__ + "img/place_outline.1d5ad6bf.svg";